import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { get, post } from 'api/requests';

import { AppThunk } from 'store/types';
import { IMedia, IParamsReq } from 'types';
import { EnDocumentsInitial, EnDocumentsList } from 'features/Documents/types';

const initialState: EnDocumentsInitial = {
  list: [],
  loading: false,
  uploadLoading: false,
};

const reset: CaseReducer<EnDocumentsInitial> = () => initialState;

const loading: CaseReducer<EnDocumentsInitial, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const list: CaseReducer<EnDocumentsInitial, PayloadAction<EnDocumentsList[]>> = (state, action) => {
  state.list = action.payload;
};

const uploadLoading: CaseReducer<EnDocumentsInitial, PayloadAction<boolean>> = (state, action) => {
  state.uploadLoading = action.payload;
};

export const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    reset,
    loading,
    list,
    uploadLoading,
  },
});

const {
  reset: setReset,
  loading: setLoading,
  list: setCurrentSettings,
  uploadLoading: setUploadLoading,
} = documentsSlice.actions;

const enDocumentsReset = (): AppThunk => dispatch => {
  dispatch(setReset());
};

const setEnDocuments =
  (settings: EnDocumentsList[]): AppThunk =>
  dispatch => {
    dispatch(setCurrentSettings(settings));
  };

export const getEnDocuments =
  (search: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<EnDocumentsList[]>('/api/standards/en-docs/get-all/', { ...search })
      .then(({ data }) => {
        dispatch(setEnDocuments(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const postUploadScan =
  (file: IMedia, type: string, tip: string, id: number, search: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setUploadLoading(true));

    post('/api/standards/en-docs/', {
      ...file,
      type: tip.toUpperCase(),
      kind: type,
      [tip]: id,
    })
      .then(() => {
        dispatch(getEnDocuments(search));
      })
      .finally(() => dispatch(setUploadLoading(false)));
  };

export const getFile = (type: string, id: number, callback?: () => void) => {
  get(`/api/standards/document/${type}-en/${id}/`, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'blob',
    },
  })
    // @ts-ignore TODO TS err
    .then(result => downloadFile(result))
    .finally(() => {
      callback && callback();
    });
};

/* TODO TS AxiosResponse<never> */
export const downloadFile = (result: AxiosResponse<never>) => {
  const [, filename] = result.headers['content-disposition'].split('filename=');
  const url = window.URL.createObjectURL(new Blob([result.data]));
  const link = document.createElement('a');

  link.href = url;
  /* TODO с сервера приходит разный нэйм(в разных разделах), 
  понять причину, вынести в общий хэлпер
  */
  link.setAttribute('download', filename.slice(1, -1));

  document.body.appendChild(link);
  link.click();
  link.remove();
};

export { enDocumentsReset };
